import CryptoJS from "crypto-js";
import { USER_TYPE_PREFIX } from "./prefixes";

export const encryptUserRole = (role) => {
  return CryptoJS.SHA256(USER_TYPE_PREFIX + role);
};

export const USER_TYPES = {
  admin: encryptUserRole("admin").toString(CryptoJS.enc.Hex),
  customer: encryptUserRole("customer").toString(CryptoJS.enc.Hex),
  superAdmin: encryptUserRole("super-admin").toString(CryptoJS.enc.Hex),
  staff: encryptUserRole("staff").toString(CryptoJS.enc.Hex),
};
